module.exports = __webpack_public_path__ + "static/21-09-25 12-26-20 DE85-square-888ca8a5910d563cf40b07773d684d51.jpg";